/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Event_TitleInputs */

const en_add_event_title = /** @type {(inputs: Add_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Event`)
};

const fr_add_event_title = /** @type {(inputs: Add_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer un Evenement`)
};

const de_add_event_title = /** @type {(inputs: Add_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis einfügen`)
};

const it_add_event_title = /** @type {(inputs: Add_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci evento`)
};

const ru_add_event_title = /** @type {(inputs: Add_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить событие`)
};

const es_add_event_title = /** @type {(inputs: Add_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar evento`)
};

const zh_cn2_add_event_title = /** @type {(inputs: Add_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入事件`)
};

const ja_add_event_title = /** @type {(inputs: Add_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを挿入`)
};

const hi_add_event_title = /** @type {(inputs: Add_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट डालें`)
};

const pt_pt2_add_event_title = /** @type {(inputs: Add_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir evento`)
};

/**
* | output |
* | --- |
* | "Insert Event" |
*
* @param {Add_Event_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const add_event_title = /** @type {((inputs?: Add_Event_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Event_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_add_event_title(inputs)
	if (locale === "de") return de_add_event_title(inputs)
	if (locale === "it") return it_add_event_title(inputs)
	if (locale === "ru") return ru_add_event_title(inputs)
	if (locale === "es") return es_add_event_title(inputs)
	if (locale === "zh-CN") return zh_cn2_add_event_title(inputs)
	if (locale === "ja") return ja_add_event_title(inputs)
	if (locale === "hi") return hi_add_event_title(inputs)
	if (locale === "pt-PT") return pt_pt2_add_event_title(inputs)
	return en_add_event_title(inputs)
});